module.exports = __webpack_public_path__ + "img/AS.832c589b.png";